"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var anim_values_1 = require("./anim-values");
var AnimationType = /** @class */ (function () {
    function AnimationType() {
    }
    AnimationType.defaultSlideVal = function () {
        return 1000;
    };
    AnimationType.slideFromBottom = function (yPos) {
        if (yPos === void 0) { yPos = this.defaultSlideVal(); }
        var startSlideVal = { translateY: [Math.abs(yPos || this.defaultSlideVal()), 0] };
        var fadeInVal = { opacity: [0, 1] };
        return Object.assign({}, startSlideVal, fadeInVal);
    };
    AnimationType.slideToBottom = function (yPos) {
        if (yPos === void 0) { yPos = this.defaultSlideVal(); }
        return {
            opacity: [1, 0],
            translateY: [0, (Math.abs(yPos))],
        };
    };
    AnimationType.slideFromTop = function (yPos) {
        if (yPos === void 0) { yPos = this.defaultSlideVal(); }
        var startSlideVal = { translateY: [-(Math.abs(yPos || this.defaultSlideVal())), 0] };
        var fadeInVal = { opacity: [0, 1] };
        return Object.assign({}, startSlideVal, fadeInVal);
    };
    AnimationType.slideToTop = function (yPos) {
        if (yPos === void 0) { yPos = this.defaultSlideVal(); }
        return {
            opacity: [1, 0],
            translateY: [0, -(Math.abs(yPos))],
        };
    };
    AnimationType.slideFromLeft = function (xPos) {
        if (xPos === void 0) { xPos = this.defaultSlideVal(); }
        return {
            opacity: [0, 1],
            translateX: [(-(Math.abs(xPos))), 0],
        };
    };
    AnimationType.slideToLeft = function (xPos) {
        if (xPos === void 0) { xPos = this.defaultSlideVal(); }
        return {
            opacity: [1, 0],
            translateX: [0, -Math.abs(xPos)],
        };
    };
    AnimationType.slideFromRight = function (xPos) {
        if (xPos === void 0) { xPos = this.defaultSlideVal(); }
        return {
            opacity: [0, 1],
            translateX: [(Math.abs(xPos) || 800), 0],
        };
    };
    AnimationType.slideToRight = function (xPos) {
        if (xPos === void 0) { xPos = 1000; }
        return {
            opacity: [1, 0],
            translateX: [0, Math.abs(xPos)],
        };
    };
    AnimationType.show = function () {
        return {
            opacity: [0, 1],
        };
    };
    AnimationType.resetVisibility = function () {
        return {
            opacity: [1, 1],
        };
    };
    AnimationType.hide = function () {
        return {
            height: 0,
            opacity: [1, 0],
        };
    };
    AnimationType.fadeIn = function () {
        return {
            opacity: [0, 1],
        };
    };
    AnimationType.fadeOut = function () {
        return {
            opacity: [1, 0],
        };
    };
    AnimationType.open = function () {
        return {
            opacity: [0, 1],
            scale: [0, 1],
        };
    };
    AnimationType.close = function () {
        return {
            opacity: [1, 0],
            scale: [1, 0],
        };
    };
    AnimationType.scaleFont = function (fromTo) {
        return {
            fontSize: fromTo,
        };
    };
    AnimationType.scale = function (fromTo) {
        return {
            scale: fromTo,
        };
    };
    AnimationType.rotate = function (rotateProps) {
        return {
            rotate: rotateProps,
        };
    };
    AnimationType.setTransformOrigin = function (transformOrigin) {
        if (transformOrigin) {
            switch (transformOrigin) {
                case anim_values_1.TransformOrigin.TOP_LEFT:
                    return { transformOrigin: ['0% 0% 0%', '0% 0% 0%'] };
                case anim_values_1.TransformOrigin.TOP_MIDDLE:
                    return { transformOrigin: ['50% 0% 0%', '50% 0% 0%'] };
                case anim_values_1.TransformOrigin.TOP_RIGHT:
                    return { transformOrigin: ['100% 0% 0%', '100% 0% 0%'] };
                case anim_values_1.TransformOrigin.CENTER_LEFT:
                    return { transformOrigin: ['0% 50% 0%', '0% 50% 0%'] };
                case anim_values_1.TransformOrigin.CENTER_MIDDLE:
                    return { transformOrigin: ['50% 50% 0%', '50% 50% 0%'] };
                case anim_values_1.TransformOrigin.CENTER_RIGHT:
                    return { transformOrigin: ['100% 50% 0%', '100% 50% 0%'] };
                case anim_values_1.TransformOrigin.BOTTOM_LEFT:
                    return { transformOrigin: ['0% 100% 0%', '0% 100% 0%'] };
                case anim_values_1.TransformOrigin.BOTTOM_MIDDLE:
                    return { transformOrigin: ['50% 100% 0%', '50% 100% 0%'] };
                case anim_values_1.TransformOrigin.BOTTOM_RIGHT:
                    return { transformOrigin: ['100% 100% 0%', '100% 100% 0%'] };
            }
        }
        else {
            return { transformOrigin: ['50% 50% 0%', '50% 50% 0%'] };
        }
    };
    AnimationType.custom = function (custom) {
        return custom;
    };
    return AnimationType;
}());
exports.default = AnimationType;
//# sourceMappingURL=anim-types.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Animate/models/anim-types.js
// module id = 1102
// module chunks = 8